import DetailsMemberUser from "./account/DetailsMemberUser";
import NavMenu from "./nav-menu/nav-menu";
import SystemErrors from "./shared/SystemErrors";
import Footer from "./shared/Footer";
import DownloadProgressModal from "./reports/DownloadProgressModal";
import GcpUnavailableModal from "./shared/GcpUnavailableModal";

const Layout = ({ children }) => {
  return (
    <div>
      <NavMenu />
      <SystemErrors />
      {children}
      <DetailsMemberUser />
      <Footer />
      <DownloadProgressModal />
      <GcpUnavailableModal />
    </div>
  );
};

export default Layout;